import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  // 承诺书列表
  commitmentLetterList: baseURL + '/trade/app/personal/commitmentLetter/page',
  // 框架协议列表
  protocolList: baseURL + '/trade/app/personal/frame/protocol/page',
  // 合同列表
  contractList: baseURL + '/trade/app/personal/contract/page'
};

export default api;
